module.exports = __webpack_public_path__ + "img/salon.ed598b13.png";